import React, { useEffect, useState } from "react"

import { ProductFields, ToggleButton } from "@tenforce/product-fields"

import { GlobalState } from "../../../../store"
import { useAppDispatch, useAppSelector } from "../../../../hooks"

import { updateField } from "../../slice"
import { fieldsAPI } from "../../../../apis"
import { usePrevious } from "../../../../hooks/usePreviousHook"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { IToggleButtonField } from "../../index"

export interface Props {
    field: IToggleButtonField
}

export const ToggleButtonField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const {
        isLoading,
        id,
        currentFieldInEditMode = "",
    } = useAppSelector((state: GlobalState) => state.fields)
    const [selectables, setSelectables] = useState(
        [] as ProductFields.ToggleItem[],
    )
    const [isInitialized, setIsInitialized] = useState(false)
    const {
        position: _position,
        odataType: _odataType,
        value,
        ...fieldProps
    } = field

    const prevValue = usePrevious(value)

    useEffect(() => {
        if (prevValue?.valueId === value?.valueId && isInitialized) {
            return
        }

        fieldsAPI
            .collectSelectableValues(id, field)
            .then((selectables) => setSelectables(selectables))

        if (!isInitialized) {
            setIsInitialized(true)
        }
    }, [value])

    const isDisabled =
        fieldProps.isDisabled ||
        !["", fieldProps.fieldId].includes(currentFieldInEditMode)

    return (
        <ToggleButton
            {...fieldProps}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            tabIndex={1}
            items={selectables}
            isSingleSelect={true}
            isLoading={isLoading}
            isDisabled={isDisabled}
            onSave={async (changedValue: string[]): Promise<void> => {
                const newValue =
                    changedValue?.length === 0 ? null : changedValue[0]
                await dispatch(
                    updateField({
                        field,
                        newValue,
                    }),
                ).unwrap()
            }}
        />
    )
}

export default ToggleButtonField
